<template>
    <div class="content">
        <div class="box box1">
            <div class="box1-title">【电脑系统】</div>
            <div class="box1-content box1-last">支持64位<span class="bold">Windows10</span>及以上操作系统</div>
        </div>
        <div class="step">
            <div class="step-title">
                <div class="step-number">1</div>
                <div class="step-text">地图数据下载</div>
            </div>
            <div class="step-content">
                <div class="box box2">
                    <div class="box2-title">【下载链接1】</div>
                    <div class="box2-content box1-last">百度网盘：<br/>
                        <div class="link">https://pan.baidu.com/s/1mEabEMVxiWJK8lm2khCPJg</div>
                        提取码：<span class="light">jtba</span><br>
                        下载后双击<span class="bold">手表地图传输工具.exe</span>，解压文件到本地。
                    </div>
                </div>
                <div class="box box2">
                    <div class="box2-title">【下载链接2】</div>
                    <div class="box2-content box1-last">阿里云盘：<br>
                        <div class="link">https://www.aliyundrive.com/s/CJHijQLHrwr</div>
                        提取码：<span class="light">v3p1</span><br>
                        下载后双击<span class="bold">手表地图传输工具.exe</span>，解压文件到本地。
                    </div>
                </div>
            </div>
        </div>
        <div class="step">
            <div class="step-title step-title2">
                <div class="step-number">2</div>
                <div class="step-text">传输工具使用</div>
            </div>
            <div class="step-content">
                <div class="step2-text">
                    下载后先双击解压，解压后点击运行<span class="bold">“setup.exe”</span>，将地图工具软件进行安装。<span class="bold">建议不要安装在C盘，如果必须安装在C盘，安装后请右键点击图标-属性--兼容性-勾上用管理员权限运行此程序。</span>
                </div>
                <div class="box box2">
                    <div class="box2-title">【一】连接手表</div>
                    <div class="box-sub-titel">1、驱动安装：</div>
                    <div class="box-sub-content">
                        当手表的USB充电线插入电脑USB端口，会弹出<span class="bold"> “安装驱动”</span>的提示，等待一会弹出“驱动安装成功”。
                    </div>
                    <div class="box-sub-titel">2、查看手表端口号：</div>
                    <div class="box-sub-content">
                        点击软件第4步的（<span class="light"> 查看端口号链接？</span>），弹出的对话框选择<span class="bold">“是”</span>，将自动打开设备管理器，查看端口里<span
                            class="bold">Silicon Labs CP210X USB to UART Bridge</span>括号后的<span
                            class="bold">端口号</span>。 如果有的电脑打开后没有“端口”就在选项栏点击<span
                            class="bold">“查看”-“显示隐藏的设备”</span>。
                    </div>
                    <div class="error">异常情况</div>
                    <div class="box-sub-titel error-sub">1、电脑弹出无法识别的USB设备？</div>
                    <div class="box-sub-content">
                        1）点开软件上方的<span class="bold">“驱动”</span>，解压文件夹中<span class="bold">“【主驱动CP210x_Universal_Windows_Driver.zip】”</span>，接下来需要在<span
                            class="bold">“设备管理器”</span>下的<span class="bold">“端口”</span>或者<span
                            class="bold">“通用串行总控制器”</span>或<span
                            class="bold">“未知设备”</span>里找到有<span class="bold">黄色<span class="yellow">【！】</span>“未知USB设备”</span>，选中该设备<span
                            class="bold">右键点击-更新驱动程序-浏览我的电脑</span>以查找驱动程序，手动浏览文件夹选择<span
                            class="bold">放USB驱动程序的文件夹</span>安装驱动，可参考视频教程。
                    </div>
                    <div class="box-sub-content">
                        2）<span class="bold">将USB线与手表断开，反方向与手表再连接。（提示无法识别的USB 设备是插反了，</span>部分手表USB线箭头标识是反的）。
                    </div>
                    <div class="box-sub-content">
                        3）<span class="bold">按照上方第2点查看手表端口号</span>，如果成功就会出现端口；
                    </div>
                    <img class="img" src="@/assets/map/map1.png">
                    <div class="box-sub-content">4）如果仍然没有端口，查看<span class="bold">【其他设备】</span>里是否出现了<span
                            class="bold">Silicon Labs CP210X USB to UART Bridge</span>或者<span
                            class="bold">未知设备</span>，出现了就<span class="bold">再次右键-更新程序-浏览我的电脑</span>以查找驱动程序，<span
                            class="bold">将驱动再安装一次</span>就可以了。
                    </div>
                    <div class="box-sub-titel error-sub">2、提示驱动安装失败</div>
                    <div class="box-sub-content">1）按照异常<span class="error-sub">情况1</span>的步骤手动安装一次驱动。</div>
                    <div class="box-sub-content">2）如果失败，请下载<span class="bold">备用驱动</span>进行安装。</div>
                    <div class="box-sub-content">3）如果仍然失败，请下载<span class="bold">【驱动精灵】</span>软件修复一下电脑的驱动。</div>
                    <div class="box-sub-content">4）如果仍然不出现端口号，联系客服寄回并告知下载的地图区域（2-3个市）由厂家帮忙下载。</div>
                    <div class="box2-title">【二】下载地图</div>
                    <div class="box-sub-content">点击第二步<span class="bold">“选择区域”</span>按钮</div>
                    <img src="@/assets/map/map2.png" class="img">
                    <div class="box-sub-content">
                        选择想要下载的<span class="bold">省-市-区</span>，然后点击<span class="bold">“确定”</span>，就会锁定要下载的区域，由于传输速度较慢，建议用户先从区开始试用（<span
                            class="bold">区</span>传输时间约为<span class="bold">1-3</span>小时,以实际情况为准,手表最大支持<span
                            class="bold">8GB</span>地图数据,<span class="bold">支持多次下载不同区域</span>的地图数据,手表端会自动追加保存）。
                    </div>
                    <img src="@/assets/map/map3.png" class="img">
                    <div class="box-sub-content"> 选中下载区域后,点击软件<span class="bold">“开始下载”</span>，会弹出<span
                            class="bold">“下载设置”</span>，选择合适的存储路径后点击<span class="bold">“确定”</span>进入下载页面。
                    </div>
                    <img src="@/assets/map/map4.png" class="img">
                    <div class="box-sub-content">
                        下载页面当进度条结束时，弹出<span class="bold">“下载完成”</span>，点击确定按钮回到地图传输软件。(下载完成后,请勿修改下载地图数据)。
                    </div>
                    <img src="@/assets/map/map5.png" class="img">
                    <div class="box2-title">【三】处理地图</div>
                    <div class="box-sub-content">第三步点击<span class="bold">“开始处理”</span>，会弹出对话框，自动定位到刚才下载的地图路径，注意请选择<span
                            class="bold">MAP文件夹</span>（即13、14、15、16文件夹的上一层，如已自动选中，则无需操作，如未选中，则手动选中MAP）。
                    </div>
                    <div class="box2-title">【四】传输地图</div>
                    <div class="box-sub-content box1-last">
                        根据<span class="bold">【一】连接手表-第2点</span>查看手表端口号，在软件界面下拉选择端口号，点击开始传输。开始传输后，需要与手表建立连接，耗时10-15s左右，建立连接后开始传输地图文件，手表界面显示<span
                            class="bold">“离线地图更新中”</span>，传输进度会实时显示在软件页面上。 传输完成后，会弹出“传输成功”，<span class="bold">此时取下手表长按back键回复到手表表盘页面</span>，进入菜单项-地图-即可使用已下载区域的地图。进入手表地图功能，需要等待定位，定位未成功时手表不显示地图，定位成功后就会显示地图了。<br><span
                            class="bold">注意：请下载与自己地理位置吻合的地图，否则会因为定位不匹配无法显示在手表上。</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="step">
            <div class="step-title step-title2">
                <div class="step-number">3</div>
                <div class="step-text">常见问题</div>
            </div>
            <div class="step-content">
                <div class="box box2">
                    <div class="box2-title">【一】增加“清空电脑处理数据”功能</div>
                    <div class="box-sub-content"> 该功能在标题栏“选项”下拉菜单中，用途是<span class="bold">清空已导入的地图数据</span>，注意“清空”功能是针对用户不想继续传输之前已选择的的地图区域，并不清空手表里的地图数据。<br>
                        如果手表端有某个区域的地图数据后，请用户不要再多次传输同一区域的地图，由于FLASH擦写次数限制，可能会引起手表的FLASH错误。
                    </div>
                    <div class="box2-title">【二】地图下载功能点击“下载”按钮无响应</div>
                    <div class="box-sub-content">请关闭360安全卫士、360杀毒软件等类似安全软件后重试。</div>
                    <div class="box2-title">【三】处理地图时弹出attempt to write a readonly database或点击视频教程无响应</div>
                    <div class="box-sub-content">
                        这是安装在C盘，权限不够引起的，<span class="bold">右键点击图标-属性--兼容性-勾上用管理员权限</span>运行此程序。或者卸载安装到其他盘符中。
                    </div>
                    <div class="box2-title">【四】增加格式化手表地图功能</div>
                    <div class="box-sub-content">此功能和<span
                            class="bold">【四】传输地图</span>一样，需要用到串口号，链接好手表后，选中正确的串口号，再点击<span
                            class="bold">“格式化手表地图功能”</span>，等待10-20s左右，会提示格式化成功与否
                    </div>
                    <div class="box2-title">【五】点击异常情况，视频教程无响应</div>
                    <div class="box-sub-content box1-last">
                        这是安装在C盘，权限不够引起的，<span class="bold">右键点击图标-属性--兼容性-勾上用管理员权限</span>运行此程序。或者卸载安装到其他盘符中。
                    </div>
                </div>
            </div>
        </div>
        <div class="step">
            <div class="step-title step-title2">
                <div class="step-number">4</div>
                <div class="step-text">其他声明</div>
            </div>
            <div class="prop">本软件不提供地图数据服务,该地图数据为第三方控件数据, 地图数据下载为用户个人行为,请勿随意传播地图数据,其造成的法律风险请自行负责。</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'instructions',
        data: {
            return: {
                active: 'a'
            }
        }
    }
</script>

<style scoped>

    .content {
        background-color: #FFFFFF;
        color: #000000;
        padding-top: 20px;
        width: 100%;
    }

    .box {
        width: 330px;
        margin-left: 30px;
        background: #F7F7F7;
        border-radius: 7px 7px 7px 7px;
        margin-bottom: 10px;
    }

    .box1-title {
        font-size: 13px;
        font-weight: bold;
        padding-left: 11px;
        padding-top: 13px;
    }

    .box1-content {
        font-size: 13px;
        padding-left: 18px;
        padding-top: 11px;
    }

    .box1-last {
        padding-bottom: 13px;
    }

    .step-title {
        width: 136px;
        height: 24px;
        background-color: #00BB7C;
        border-radius: 12px;
        margin-top: 19px;
        margin-left: 8px;
        position: relative;
    }

    .step-number {
        width: 20px;
        height: 20px;
        border-radius: 10px;
        background: #FFFFFF;
        position: absolute;
        left: 2px;
        top: 2px;
        color: #00BB7C;
        font-size: 18px;
        line-height: 20px;
        text-align: center;
    }

    .step-text {
        color: #FFFFFF;
        font-size: 15px;
        position: absolute;
        left: 32px;
        top: 5px;
        line-height: 14px
    }

    .step-content {
        border-left: 2px dashed #D2D2D2;
        width: 354px;
        margin-left: 20px;
        padding: 16px 0 6px 0;
    }

    .box2 {
        margin-left: 10px;
        font-size: 12px;
    }

    .link {
        color: #00BB7C;
        word-break: break-all;
        text-decoration: underline;
    }

    .light {
        color: #00BB7C;
        text-decoration: underline;
    }

    .box2-title {
        font-size: 12px;
        font-weight: bold;
        padding-left: 11px;
        padding-top: 13px;
        word-break: break-all;
    }

    .box2-content {
        font-size: 12px;
        padding-left: 18px;
        padding-top: 10px;
        line-height: 24px;
    }

    .step-title2 {
        margin-top: 0;
    }

    .bold {
        font-weight: bold;
    }

    .step2-text {
        font-size: 13px;
        width: 308px;
        margin-left: 28px;
        line-height: 23px;
        margin-bottom: 12px;
    }

    .box-sub-titel {
        margin-left: 30px;
        margin-top: 12px;
        font-size: 12px;
        font-weight: bold;
    }

    .box-sub-content {
        margin-left: 30px;
        margin-top: 8px;
        font-size: 12px;
        line-height: 24px;
        margin-right: 8px;
    }

    .error {
        width: 69px;
        height: 24px;
        border-radius: 11px 11px 11px 11px;
        opacity: 1;
        border: 1px solid #D91919;
        color: #D91919;
        text-align: center;
        line-height: 24px;
        margin-top: 15px;
        margin-left: 20px;
    }

    .error-sub {
        color: #D91919;
    }

    .yellow {
        color: #EAEA4C;
    }

    .img {
        width: 292px;
        margin-left: 30px;
        margin-top: 10px;
    }

    .prop {
        font-size: 13px;
        margin-left: 37px;
        margin-top: 17px;
        width: 308px;
        padding-bottom: 23px;
        line-height: 22px;
    }

    .step3-text {
        width: 300px;
        font-size: 13px;
        margin-left: 28px;
        line-height: 24px;
        margin-bottom: 12px;
    }

    .img2 {
        width: 166px;
        margin-left: 28px;
        margin-top: 0;
    }

    .other-box {
        margin-top: 13px;
        margin-left: 41px;
        margin-right: 19px;
    }

    .other-title {
        font-size: 13px;
        font-weight: bold;
    }

    .other-content {
        font-size: 13px;
        margin-left: 2px;
        line-height: 24px;
        margin-top: 6px;
    }

    .box3 {
        padding-right: 10px;
        width: 320px;
    }
</style>



// WEBPACK FOOTER //
// src/views/map/ta900desc.vue